import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { createRoot } from "react-dom/client";
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import jwtDecode from "jwt-decode";

// After a new deploy, stale cached bundles may reference old chunk hashes.
const CHUNK_RELOAD_KEY = "chunk_reload";
window.addEventListener("error", (event) => {
  const message = event?.message || "";
  const isChunkError =
    message.includes("Loading chunk") ||
    message.includes("ChunkLoadError") ||
    event?.error?.name === "ChunkLoadError";
  if (!isChunkError) return;
  const reloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  if (!reloaded) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
    window.location.reload();
  }
});
window.addEventListener("load", () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

const authLink = setContext((_, { headers }) => {
  // Check for admin token first
  let loggedUserParsed = null;
  try {
    const loggedUserJSON = window.localStorage.getItem("loggedUser");
    if (loggedUserJSON) {
      loggedUserParsed = JSON.parse(loggedUserJSON);
    }
  } catch (e) {
    console.error("Error parsing loggedUser:", e);
  }

  // Check for trainer portal token if admin token not found
  let trainerTokenParsed = null;
  try {
    const trainerTokenJSON = window.localStorage.getItem("trainerPortalToken");
    if (trainerTokenJSON) {
      trainerTokenParsed = JSON.parse(trainerTokenJSON);
    }
  } catch (e) {
    console.error("Error parsing trainerPortalToken:", e);
  }

  // Use admin token if available, otherwise use trainer token
  const tokenData = loggedUserParsed || trainerTokenParsed;

  if (tokenData && tokenData.token) {
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${tokenData.token}`,
      },
    };
  }
  return {
    headers: { ...headers },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log("graphql", graphQLErrors);
    graphQLErrors.forEach(({ extensions }) => {
      if (
        extensions.code === "invalid-headers" ||
        extensions.code === "invalid-jwt"
      ) {
        // Check if we're in trainer portal or admin portal
        const path = window.location.pathname;
        const isTrainerPortal =
          path.startsWith("/affiliatorportal") ||
          path.startsWith("/trainerportal") ||
          path.startsWith("/trainer-portal");
        if (isTrainerPortal) {
          localStorage.removeItem("trainerPortalToken");
          window.location.assign(`${window.location.origin}/affiliatorportal/login`);
        } else {
          localStorage.removeItem("loggedUser");
          window.location.assign(`${window.location.origin}/login`);
        }
      }
    });
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    alert("network connection problem");
  }
});

const httpLink = new HttpLink({ uri: "https://graphql.powerplay.axra.com.mm/v1/graphql" });
// const httpLink = new HttpLink({ uri: "https://stag.graphql.powerplay.axra.com.mm/v1/graphql" });

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(authLink).concat(httpLink),
});
console.log("connected ......");
const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </BrowserRouter>
);
